/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_TitleInputs */

const en_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Captions`)
};

const fr_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustation de sous-titres`)
};

const de_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel einbetten`)
};

const it_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora didascalie`)
};

const ru_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить субтитры`)
};

const es_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar subtítulos`)
};

const zh_cn2_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入字幕`)
};

const ja_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションを埋め込む`)
};

const hi_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन एम्बेड करें`)
};

const pt_pt2_embed_captions_title = /** @type {(inputs: Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar legendas`)
};

/**
* | output |
* | --- |
* | "Embed Captions" |
*
* @param {Embed_Captions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_title = /** @type {((inputs?: Embed_Captions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_title(inputs)
	if (locale === "de") return de_embed_captions_title(inputs)
	if (locale === "it") return it_embed_captions_title(inputs)
	if (locale === "ru") return ru_embed_captions_title(inputs)
	if (locale === "es") return es_embed_captions_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_title(inputs)
	if (locale === "ja") return ja_embed_captions_title(inputs)
	if (locale === "hi") return hi_embed_captions_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_title(inputs)
	return en_embed_captions_title(inputs)
});